import { Row } from "@hightouch/htui";
import { useNavWidth } from "src/contexts/nav-width-context";
import { HightouchLogo } from "src/ui/icons";
import { Logo as MobileLogo } from "src/ui/brand";

export const PoweredBy = () => {
  const { isNavOpen } = useNavWidth();

  return (
    <Row cursor="default" align="center" px={2} mt={1}>
      {isNavOpen ? (
        <HightouchLogo height="15px" width="84px" color="gray.600" />
      ) : (
        <MobileLogo
          size="16px"
          theme="dark"
          fill="var(--chakra-colors-gray-600)"
          sx={{ mx: "auto" }}
        />
      )}
    </Row>
  );
};
